import i18n from "../i18n";

var selected_language = localStorage.getItem("language");
if (selected_language == '') {
    selected_language = 'en'
    i18n.locale = "en"
}
if (selected_language == "fa") {
    i18n.locale = "fa"
}
export default [
    {
        _name: 'CSidebarNav',
        redirect:'/dashboard/main/costs',
        _children: [
            {
                _name: 'CSidebarNavItem',
                // _name: 'CSidebarNavDropdown',
                name: i18n.t('sidebars.dashboard'),
                to: '/dashboard/main/costs',
                icon: 'cil-speedometer',
                role: 'Dashboards',

            },

            // **************************
            {

                _name: 'CSidebarNavDropdown',
                name: i18n.t('sells'),
                route: '/dashboard/sale-orders',
                icon: 'cil-chart-line',
                role: 'Sales',

                items: [
                    {
                        name: i18n.t('newCustomer'),
                        to: '/dashboard/sale-orders/add-customer',
                        role: 'Customers'
                    },
                    {
                        name: i18n.t('SellInvoice'),
                        to: '/dashboard/sale-orders/sale-invoice',
                        role: 'SaleInvoice'
                    },
                    {
                        name: i18n.t('salesPlan'),
                        to: '/dashboard/sale-orders/sale-program',
                        role: 'SellProgram',
                        role_access: 'sell_program'
                    },
                    {
                        name: i18n.t('jashnvare'),
                        to: '/dashboard/sale-orders/eshantions',
                        role: 'Eshantions',
                        role_access: 'jashnvare',

                    },

                    {
                        name: i18n.t('sidebars.reports'),
                        to: '/dashboard/sale-orders/list-customer'
                        , role: 'SaleReport'
                    },
                    {
                        name: "حواله های تامین کننده",
                        to: '/dashboard/sale-orders/supplier_factors'
                        , role: 'SaleReport',
                        role_access: 'sell_supplier_direct'


                    }, {
                        name: "فاکتور های واحد صنفی",
                        to: '/dashboard/sale-orders/customer_factors',
                        role: 'SaleReport',
                        role_access: 'sell_supplier_direct'

                    },

                ]
            },

            //**************************8
            {
                _name: 'CSidebarNavDropdown',
                name: i18n.t('sidebars.delivery'),
                route: '/dashboard/delivery',
                icon: 'cil-truck',
                role: 'Delivery',
                role_access: 'delivery',

                items: [

                    {
                        name: i18n.t('deliveryOperation'),
                        to: '/dashboard/delivery/order-list',
                        role: 'DeliveryOperation'
                    }, {
                        name: i18n.t('sidebars.reports'),
                        to: '/dashboard/delivery/delivery-report',
                        role: 'DeliveryReport'
                    }, {
                        name: i18n.t('sidebars.tracking'),
                        to: '/dashboard/delivery/tracking',
                        role: 'Routes',
                        role_access: 'delivery_tracking'
                    },

                    {
                        name: i18n.t('deliverySettings'),
                        to: '/dashboard/delivery/delivery-settings',
                        role: 'DeliveryOperation'
                    },
                ]
            },
            //**************************8 //**************************8
            {
                name: i18n.t('sidebars.orders'),

                _name: 'CSidebarNavDropdown',
                route: '/dashboard/orders',
                icon: 'cil-cart',
                role: 'Purchase',

                items: [
                    {
                        name: i18n.t('newSupplier'),
                        to: '/dashboard/orders/add-supplier'
                        , role: 'Suppliers'

                    },
                    {
                        name: i18n.t('sidebars.addBuyDocument'),
                        to: '/dashboard/orders/purchase-doc/1'
                        , role: 'BuyOrder'
                    },
                    {
                        name: i18n.t('buyFactorCurrency'),
                        to: '/dashboard/orders/create-currency/:type_id',
                        role: 'FactorCurrency',
                        role_access:'buyCurrency',
                    },
                    {
                        name: i18n.t('buyOperation'),
                        to: '/dashboard/orders/add-order'
                        , role: 'BuyOrder',
                        role_access:'buy_operation',

                    },


                    {
                        name: i18n.t('sidebars.reports'),
                        to: '/dashboard/orders/report'
                        , role: 'PurchaseQtyReport'
                    },

                ]
            },
            //**************************8 //**************************8
            {
                name: "فروش مستقیم",

                _name: 'CSidebarNavDropdown',
                route: '/dashboard/direct-sell',
                icon: 'cil-calculator',
                role: 'Purchase',
                role_access: 'driver_products',

                items: [
                    {
                        name: "کالا های در راه",
                        to: '/dashboard/direct-sell/driver-products',
                        role_access: 'driver_products'
                    }, {
                        name: "حواله های فروش",
                        to: '/dashboard/direct-sell/sale-doc-list',
                        role_access: 'driver_products'
                    },


                ]
            },

            //**************************8 //**************************8

            {

                _name: 'CSidebarNavDropdown',
                name: i18n.t('sidebars.inventory'),
                route: '/dashboard/products',
                icon: 'cil-barcode',
                role: 'Store',

                items: [
                    {
                        name: i18n.t('sidebars.addProduct'),
                        to: '/dashboard/products/create',
                        role: 'NewProduct/Edit'
                    },
                    {
                        name: i18n.t('sidebars.listProduct'),
                        to: '/dashboard/products/list',
                        role: 'ProductList'
                    },
                    {
                        name: i18n.t('returnOperation'),
                        to: '/dashboard/products/inventory-return-operation',
                        role: 'WarehouseOperation'
                    },
                    {
                        name: i18n.t('sidebars.inventoryTransfer'),
                        to: '/dashboard/products/inventory-operation',
                        role: 'WarehouseOperation'
                    },
                    {
                        name: i18n.t('sidebars.reports'),
                        to: '/dashboard/products/inventory-reports',
                        role: 'WarehouseOperation'
                    },



                ]
            },
            //**************************8 //**************************8

            //**************************8 //**************************8
            {

                _name: 'CSidebarNavDropdown',
                name: i18n.t('sidebars.accounting'),
                route: '/dashboard/accounting',
                icon: 'cil-calculator',
                role: 'Accounting',

                items: [

                    {
                        name: i18n.t('sidebars.receiveOperation'),
                        to: '/dashboard/accounting/receive-operation'
                        , role: 'AccountingReceive'
                    },
                    {
                        name: i18n.t('sidebars.payOperation'),
                        to: '/dashboard/accounting/pay-operation'
                        , role: 'AccountingPay'
                    }, {
                        name: i18n.t('sidebars.journal'),
                        to: '/dashboard/accounting/add-accounting-doc'
                        , role: 'AddAccountingDoc',
                        role_access: 'journal'
                    },

                    {
                        name: i18n.t('sidebars.accountingList'),
                        to: '/dashboard/accounting/accounting-groups-lists'
                        , role: 'AccountingReport',
                        role_access: 'chart_of_account'
                    },
                    {
                        name: i18n.t('CashBank'),
                        to: '/dashboard/accounting/cash-bank'
                        , role: 'AccountingCheques'
                    },

                    {
                        name: i18n.t('InventoryAdjustment'),
                        to: '/dashboard/accounting/inventory-adjustment'
                        , role: 'AccountingReport'
                    },
                    {
                        name: i18n.t('sidebars.reports'),
                        to: '/dashboard/accounting/reports'
                        , role: 'AccountingReport'
                    },
                ]
            },
            //**************************8 //**************************8

            {

                _name: 'CSidebarNavDropdown',
                name: i18n.t('sidebars.administrative'),
                route: '/dashboard/users',
                icon: 'cil-user',
                role: 'Administrator',

                items: [

                    {
                        name: i18n.t('Personals'),
                        to: '/dashboard/users/add-user'
                        , role: 'AddPersonal/Person'

                    },

                    {
                        name: i18n.t('usersList'),
                        to: '/dashboard/users/administrative'
                        , role: 'PersonalList'

                    },
                    {
                        name: i18n.t('sidebars.payroll'),
                        to: '/dashboard/users/payroll_list'
                        , role: 'PersonalList',
                        role_access: 'payroll'


                    }, {
                        name: i18n.t('persons'),
                        to: '/dashboard/users/persons'
                        , role: 'AddPersonal/Person',
                        role_access: 'administrative_persons'
                    },


                ]
            },
            //**************************8 //**************************8

            //**************************8
            {

                _name: 'CSidebarNavItem',
                name: i18n.t('sidebars.reports'),
                route: '/dashboard/reports/all',
                to: '/dashboard/reports/all',
                icon: 'cil-book',
                role: 'Reports',
                role_access: 'AllReports',
            },
            //**************************8


            //**************************8
            {
                _name: 'CSidebarNavDropdown',
                name: i18n.t('sidebars.firstInformation'),
                route: 'dashboard/base',
                icon: 'cil-settings',
                role: 'Settings',

                items: [
                    {
                        _name: 'CSidebarNavItem',
                        name: i18n.t('BaseSettings'),
                        to: '/dashboard/base/settings-list'
                        , role: 'BaseSettings'
                    },

                    {
                        _name: 'CSidebarNavItem',
                        name: i18n.t('sidebars.inventory'),
                        to: '/dashboard/base/inventory-settings',
                        role: 'Warehouses'
                    },

                    {
                        // name: 'دسته بندی ها',
                        _name: 'CSidebarNavItem',
                        name: i18n.t('defineAccounts'),
                        role: 'AccountingSetting',
                        role_access: 'setting_accounts',

                        to: '/dashboard/base/accounting-settings',
                    },
                    {
                        _name: 'CSidebarNavItem',
                        name: i18n.t('costCentersSidebar'),
                        to: '/dashboard/base/cost-centers'
                        , role: 'CostCenters',
                    },
                    {

                        _name: 'CSidebarNavItem',
                        name: i18n.t('address'),
                        route: '/dashboard/address',
                        to: '/dashboard/base/address/settings',
                        role:'Address'
                    },
                    {

                        _name: 'CSidebarNavItem',
                        name: i18n.t('DataConvert'),
                        route: '/dashboard/data-convert',
                        to: '/dashboard/base/data-convert',
                        role:'Address'
                    },


                ],

            },

            //**************************8
            //**************************8
            {

                _name: 'CSidebarNavItem',
                name: i18n.t('Help'),
                route: '/dashboard/help',
                to: '/dashboard/help',
                icon: 'cil-info',
                role: 'Help',
                role_access: 'help',
            },
            // {
            //     _name: 'CSidebarNavDropdown',
            //     name: i18n.t('sidebars.documents'),
            //     route: '/dashboard/documents',
            //     icon: 'cil-library',
            //     items: [
            //
            //
            //
            //         // {
            //         //   name:i18n.t('sidebars.allDocuments') ,
            //         //   to: '/dashboard/documents/list'
            //         //   ,role:'Documents'
            //         //
            //         // }
            //         // ,
            //
            //
            //     ]
            // },

            //**************************8 //**************************8 //**************************8 //**************************8
            //**************************8 //**************************8


        ]
    }
]
